function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenMobileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.432 2h15.135c1.287 0 2.27.984 2.27 2.27v23.46c0 1.286-.983 2.27-2.27 2.27H8.432c-1.286 0-2.27-.984-2.27-2.27V4.27c0-1.286.984-2.27 2.27-2.27zm0 23.46h15.135V4.27H8.432v21.19zm6.054 3.026h3.027c.454 0 .757-.302.757-.756s-.303-.757-.757-.757h-3.027c-.454 0-.756.303-.756.757s.302.756.756.756z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.033 20.815L11.5 19.553h11l-9.467 1.262zM14.836 18.562v-2.886h1.262l2.164 2.886h2.254l-2.614-3.517c.811-.63 1.352-1.533 1.352-2.614a3.232 3.232 0 00-3.246-3.246h-2.975v9.377h1.803zm0-7.664h1.172c.812 0 1.443.63 1.443 1.442 0 .812-.631 1.443-1.443 1.443h-1.172v-2.885z",
    fill: props.color
  }));
}

export default SvgIconRakutenMobileOutline;